import { render, staticRenderFns } from "./CustomizedTest_proposed-1755355513979.vue?vue&type=template&id=0d9391cc&scoped=true&"
import script from "./CustomizedTest_proposed-1755355513979.vue?vue&type=script&lang=js&"
export * from "./CustomizedTest_proposed-1755355513979.vue?vue&type=script&lang=js&"
import style0 from "./CustomizedTest_proposed-1755355513979.vue?vue&type=style&index=0&id=0d9391cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9391cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VDataTable,VIcon,VImg,VList,VListItem,VListItemTitle,VMenu,VTextField,VTooltip})
